import React from 'react';
import { Button } from '../ui/button';
import { t } from 'i18next';

const SimplePagination = ({ skip = 0, take = 20, total = 0, onChange, loading = false }) => {
    const currentPage = Math.floor(skip / take) + 1;
    const totalPages = Math.max(1, Math.ceil(total / take));
    const from = total === 0 ? 0 : skip + 1;
    const to = Math.min(skip + take, total);

    const goPrev = () => {
        if (skip <= 0) return;
        onChange({ skip: Math.max(0, skip - take), take });
    };

    const goNext = () => {
        if (skip + take >= total) return;
        onChange({ skip: skip + take, take });
    };

    return (
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 rounded-xl border bg-white p-4 shadow-sm">
            <div className="text-sm text-slate-600">
                {t('total')} <span className="font-semibold">{total}</span> {t('rows')} {from}-{to}
            </div>

            <div className="flex items-center gap-2">
                <Button variant="outline" onClick={goPrev} disabled={loading || skip <= 0}>
                    {t("preview")}
                </Button>

                <div className="text-sm text-slate-600 px-2">
                    {currentPage} / {totalPages}
                </div>

                <Button
                    variant="outline"
                    onClick={goNext}
                    disabled={loading || skip + take >= total}
                >
                    {t("after")}
                </Button>
            </div>
        </div>
    );
};

export default SimplePagination;